<template lang='pug'>
  el-card.audit-versions
    p.title {{ $t('历史记录') }}
    hr.divider
    audit-versions-item(
      v-for="(item, idx) in items"
      :item="item"
      :key="idx"
    )
</template>

<script>
import AuditVersionsItem from './AuditVersionsItem'
export default {
  components: {
    AuditVersionsItem
  },
  data () {
    return {
    }
  },
  props: {
    items: {
      type: Array,
      default () {
        return []
      }
    }
  },
  methods: {
  }
}
</script>

<style lang='stylus'>

</style>
